/**
 * WriteFlow day numbering: #1 = 2026-07-02 UTC (public launch on writeflow.ink).
 * PUBLIC CONVENTION — never change the epoch; it would renumber every share ever
 * posted. Pre-epoch (dev era) prompts have no number.
 * Keep in sync with server/utils/promptDayNumber.js (no shared package).
 */

const EPOCH_UTC = Date.UTC(2026, 6, 2); // 2026-07-02
const DAY_MS = 24 * 60 * 60 * 1000;

/** Day number for a prompt date (UTC calendar day), or null if pre-epoch. */
export function dateToDayNumber(date) {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  const utcDay = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  const n = Math.floor((utcDay - EPOCH_UTC) / DAY_MS) + 1;
  return n >= 1 ? n : null;
}
